import React from "react";
import { Box, Grid, Button, Tooltip, Typography } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function ShareSection() {
  const currentUrl = window.location.href;
  const companyName = "Power Electro Control India";

  const shareLinks = [
    {
      name: "WhatsApp",
      icon: <WhatsAppIcon />,
      color: "#22c55e",
      action: () => {
        window.open(
          `https://api.whatsapp.com/send?text=${encodeURIComponent(`${companyName} ${currentUrl}`)}`,
          "_blank"
        );
      },
    },
    {
      name: "Facebook",
      icon: <FacebookIcon />,
      color: "#3b5998",
      action: () => {
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
          "_blank"
        );
      },
    },
    {
      name: "SMS",
      icon: <ShareIcon />,
      color: "#06b6d4",
      action: () => {
        window.location.href = `sms:?&body=${encodeURIComponent(`${companyName} ${currentUrl}`)}`;
      },
    },
    {
      name: "Email",
      icon: <EmailIcon />,
      color: "#ef4444",
      action: () => {
        window.location.href = `mailto:?subject=${encodeURIComponent(companyName)}&body=${encodeURIComponent(`Check out ${companyName}: ${currentUrl}`)}`;
      },
    },
    {
      name: "Instagram",
      icon: <InstagramIcon />,
      color: "#e1306c",
      action: () => {
        alert("Open Instagram app and share the link in your story or feed!");
      },
    },
    {
      name: "Copy Link",
      icon: <ContentCopyIcon />,
      color: "#8b5cf6",
      action: () => {
        navigator.clipboard.writeText(currentUrl);
        alert("Link copied to clipboard!");
      },
    },
  ];

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        py: 8,
        px: 2,
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h4"
              fontWeight="700"
              sx={{
                color: "#0f172a",
                mb: 2,
                fontSize: { xs: "1.8rem", sm: "2rem" },
              }}
            >
              Share With Friends
            </Typography>
            <Box
              sx={{
                width: "60px",
                height: "4px",
                background: "linear-gradient(90deg, #3b82f6 0%, #06b6d4 100%)",
                borderRadius: "2px",
              }}
            />
          </Box>

          <Grid container spacing={2} sx={{ justifyContent: "center" }}>
            {shareLinks.map((link, index) => (
              <Grid item xs={12} sm={6} md={2} key={index} sx={{ display: "flex" }}>
                <Tooltip title={`Share on ${link.name}`}>
                  <Button
                    fullWidth
                    onClick={link.action}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                      py: 3,
                      minHeight: "140px",
                      background: "white",
                      border: `2px solid ${link.color}20`,
                      borderRadius: "16px",
                      color: link.color,
                      transition: "all 0.3s ease",
                      textTransform: "none",
                      fontSize: "0.95rem",
                      fontWeight: "600",
                      "&:hover": {
                        background: `${link.color}10`,
                        border: `2px solid ${link.color}60`,
                        transform: "translateY(-4px)",
                        boxShadow: `0 10px 30px ${link.color}30`,
                      },
                      "&:active": {
                        background: "white",
                        border: `2px solid ${link.color}20`,
                        transform: "none",
                      },
                      "&:focus": {
                        background: "white",
                        border: `2px solid ${link.color}20`,
                      },
                    }}
                  >
                    <Box sx={{ fontSize: "1.8rem" }}>{link.icon}</Box>
                    {link.name}
                  </Button>
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ShareSection;
